import moment from 'moment';

export const isDateInThePast = (inputDateString: string | null) => {
  if (inputDateString) {
    return moment(inputDateString).isBefore(moment(), 'days');
  }

  return false;
};
